import React from 'react';

import get from 'lodash/get';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { FILTER_PARTNER_COMPANIES } from 'scenes/ApiIntegrations/constants';
import { apiIntegrationLink } from 'scenes/ApiIntegrations/navigation';

const RelatedEntitiesSection = ({ data }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableBody>
          <TableRow>
            <TableCell>
              <ScreenLink
                link={apiIntegrationLink}
                params={{
                  filters: {
                    [FILTER_PARTNER_COMPANIES]: [get(data, 'id')],
                  },
                }}
                target={'_blank'}
              >
                API integrations
              </ScreenLink>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RelatedEntitiesSection;
